import { useUser } from '../../contexts/UserContext';
import { Crown } from 'lucide-react';
import { useState } from 'react';
import PaymentModal from './PaymentModal';
import { Capacitor } from '@capacitor/core';
import { PurchaseService } from '../../services/PurchaseService';
import { SUBSCRIPTION_PRICE_ID } from '../../lib/stripe';
import { useLocation } from 'react-router-dom';
interface UpgradeButtonProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const buttonSizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-base',
  lg: 'px-5 py-2.5 text-lg'
};

export default function UpgradeButton({ className = '', size = 'md' }: UpgradeButtonProps) {
  const { isPremium, isAdmin } = useUser();
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();

  // Don't show upgrade button for premium or admin users
  if (isPremium || isAdmin) return null;

  const handleUpgrade = async () => {
    if (Capacitor.getPlatform() === 'ios') {
      try {
        setError(null);
        setLoading(true);
        const purchaseService = PurchaseService.getInstance();
        await purchaseService.purchasePremium();
      } catch (error: any) {
        console.error('Purchase failed:', error);
        setError(error?.message || 'Purchase failed. Please try again.');
      } finally {
        setLoading(false);
      }
    } else {
      setIsPaymentModalOpen(true);
    }
  };

  const isIosDevice = Capacitor.getPlatform() === 'ios';
  const buttonText = loading ? 'Processing...' : (isIosDevice ? 'Upgrade to Premium' : 'Upgrade for $4.99/month');

  return (
    <>
      <div className="flex flex-col items-center gap-2">
        <button
          onClick={handleUpgrade}
          disabled={loading}
          className={`${size === 'sm' ? 'px-3 py-1 text-sm' : size === 'lg' ? 'px-6 py-3 text-lg' : 'px-4 py-2'} flex items-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:from-orange-600 hover:to-orange-700'} text-white font-medium rounded-lg transition-all duration-200 ${className}`}
        >
          <Crown className="w-4 h-4" />
          <span>
            {Capacitor.getPlatform() === 'ios' 
              ? (loading ? 'Processing...' : 'Upgrade to Premium')
              : 'Upgrade for $4.99/month'
            }
          </span>
        </button>
        {error && (
          <p className="text-red-500 text-sm">{error}</p>
        )}
      </div>

      {!isIosDevice && (
        <PaymentModal
          isOpen={isPaymentModalOpen}
          onClose={() => setIsPaymentModalOpen(false)}
          priceId={SUBSCRIPTION_PRICE_ID}
        />
      )}
    </>
  );
}
